import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: any) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%', // Fix IE 11 issue
  },
  resumeTable: {
    flex: 1,
    display: 'flex',
    width: 'auto',
    maxHeight: 500,
  },
  buttonDelete: {
    color: 'white',
    '&:hover': {
      backgroundColor: 'red',
      filter: `brightness('0.9')`,
    },
  },
  textInput: {
    minWidth: '300px',
    fontSize: '12px',
    color: '#00446B',
    borderRadius: '30px',
    paddingRight: '5px',
  },
  helperText: {
    color: theme.palette.error.main,
  },
  primary: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  secundary: {
    fontSize: '16px',
  },
  createAt: {
    fontSize: '25px',
  },
}))
